





















import { defineComponent, ref } from '@vue/composition-api';
import { useModuleConfig } from './use-module-config';
import { biBrow } from '@tencent/fit-bi-sdk';
import { i18n } from '@/i18n';
import { customDocumentTitle, defaultDocumentTitle } from '@/config/document-title';
import { url } from '@tencent/ppd-base-libs';

export default defineComponent({
  name: 'HomeNewest',
  setup() {
    document.title = customDocumentTitle[url.getParamAdtag()] || defaultDocumentTitle;
    const { sortedModuleConfig } = useModuleConfig();
    const initDone = ref(false);
    biBrow('homenewest.page_brow');
    return {
      handleInitDone() {
        initDone.value = true;
      },
      sortedModuleConfig,
      initDone,
    };
  },
});
